import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "truncate flex-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-xs bg-orange-400 rounded text-white w-4 h-4 flex items-center justify-center cursor-pointer"
}
const _hoisted_4 = ["checked"]

import { onClickOutside } from "@vueuse/core";
import { computed, ref } from "vue";
import { CriticalPathEx, CriticalPathNodeEx, CriticalPathTag } from "shared/types/CriticalPath";


export default /*#__PURE__*/_defineComponent({
  __name: 'CriticalPathTagMenu',
  props: {
    position: {},
    criticalPath: {},
    selectedNodeIds: {}
  },
  emits: ["close", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const tagContextMenuContainerRef = ref<HTMLDivElement | null>(null);

onClickOutside(tagContextMenuContainerRef, () => {
  emit("close");
});

const selectedNodeIdsSet = computed(() => new Set(props.selectedNodeIds));

const nodesByTagId = computed(() =>
  props.criticalPath.nodes.reduce((acc, node) => {
    if (!selectedNodeIdsSet.value.has(node._id)) {
      return acc;
    }
    for (const tagId of node.tags) {
      if (!acc[tagId]) {
        acc[tagId] = new Set<string>();
      }
      acc[tagId].add(node._id);
    }
    return acc;
  }, {} as Record<string, Set<string>>),
);

const getNodesForTagId = (tagId: string) => nodesByTagId.value[tagId] || new Set<string>();

const addTagToNode = (node: CriticalPathNodeEx, tag: CriticalPathTag, nodesForTag: Set<string>) => {
  if (nodesForTag.has(node._id)) {
    return node;
  }
  return {
    ...node,
    tags: [...node.tags, tag._id],
  };
};

const removeTagFromNode = (node: CriticalPathNodeEx, tag: CriticalPathTag) => ({
  ...node,
  tags: node.tags.filter((tagId) => tagId !== tag._id),
});

const addOrRemoveTagToNode = (
  node: CriticalPathNodeEx,
  tag: CriticalPathTag,
  nodesForTag: Set<string>,
  { shouldAdd }: { shouldAdd: boolean },
) => {
  if (shouldAdd) {
    return addTagToNode(node, tag, nodesForTag);
  }
  return removeTagFromNode(node, tag);
};

const handleTagClick = (tag: CriticalPathTag) => {
  const nodesForTag = getNodesForTagId(tag._id);
  const shouldAdd = nodesForTag.size === 0 || nodesForTag.size !== props.selectedNodeIds.length;
  emit("change", {
    ...props.criticalPath,
    nodes: props.criticalPath.nodes.map((node) =>
      selectedNodeIdsSet.value.has(node._id)
        ? addOrRemoveTagToNode(node, tag, nodesForTag, { shouldAdd })
        : node,
    ),
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    _createElementVNode("div", {
      class: "fixed bg-white border py-1 z-[200] cursor-default w-[200px] shadow-md overflow-auto max-h-[300px]",
      ref_key: "tagContextMenuContainerRef",
      ref: tagContextMenuContainerRef,
      style: _normalizeStyle({ top: `${_ctx.position.y}px`, left: `${_ctx.position.x}px` })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criticalPath.tags, (tag) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tag._id,
          class: "px-5 py-2 hover:bg-gray-100 flex gap-2 items-center cursor-pointer",
          onClick: ($event: any) => (handleTagClick(tag))
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(tag.name), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([getNodesForTagId(tag._id)], (nodesForTag) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: nodesForTag }, [
              (nodesForTag.size > 0 && nodesForTag.size !== _ctx.selectedNodeIds.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, " - "))
                : (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    type: "checkbox",
                    checked: nodesForTag.size > 0 && nodesForTag.size === _ctx.selectedNodeIds.length,
                    class: "shrink-0 focus:ring-0 text-orange-400 rounded cursor-pointer"
                  }, null, 8, _hoisted_4))
            ], 64))
          }), 128))
        ], 8, _hoisted_1))
      }), 128))
    ], 4)
  ]))
}
}

})